<template>
  <form id="form-add-medicine" class="position-relative">
    <loader :loading="loadingForm" block />
    <div class="vuedl-layout__closeBtn" @click="close(true)">
      ×
    </div>
    <v-card>
      <v-card-title class="headline grey lighten-2 mb-4" primary-title>Добавить лекарство</v-card-title>
      <v-card-text class="py-1">
        <v-autocomplete
          label="Наименование"
          placeholder="Напишите названия лекарства для поиска"
          hide-no-data
          hide-selected
          prepend-icon="mdi-plus"
          item-text="name"
          item-value="id"
          required
          v-model="form.drugId"
          :items="drugsList"
          :loading="loadingDrugs"
          :error-messages="nameErrors"
          :search-input.sync="searchDrugs"
          @input="$v.form.drugId.$touch()"
          @blur="$v.form.drugId.$touch()"
          @change="selectDrug"
          @click:prepend="addNewMedicineName"
        >
        </v-autocomplete>
      </v-card-text>

      <v-card-text class="py-1">
        <v-select
          label="Форма выпуска"
          required
          item-text="name"
          item-value="id"
          v-model="form.form"
          :loading="drugFormsListLoading"
          :items="drugFormsList"
          :error-messages="drugFormErrors"
          @change="$v.form.form.$touch()"
          @blur="$v.form.form.$touch()"
        />
      </v-card-text>

      <v-card-text class="py-1">
        <v-select
          label="Производитель"
          required
          item-text="name"
          item-value="id"
          v-model="form.manufacturer"
          :loading="manufacturerListLoading"
          :items="manufacturerList"
          :error-messages="manufacturerErrors"
          @change="$v.form.manufacturer.$touch()"
          @blur="$v.form.manufacturer.$touch()"
        />
      </v-card-text>

      <v-card-text class="py-1">
        <v-select
          label="Способ приема"
          item-text="text"
          item-value="id"
          v-model="form.receptionMethod"
          :loading="loadingFieldsData"
          :items="receptionMethods"
          :error-messages="receptionMethodErrors"
          @change="$v.form.receptionMethod.$touch()"
          @blur="$v.form.receptionMethod.$touch()"
        />
      </v-card-text>

      <v-card-text class="py-1">
        <v-row>
          <v-col class="py-0">
            <v-text-field
              label="Дозировка"
              v-model.number="form.dosage"
              :error-messages="dosageErrors"
              @input="$v.form.dosage.$touch()"
              @blur="$v.form.dosage.$touch()"
            />
          </v-col>

          <v-col class="py-0">
            <v-select
              label="Ед. измерения"
              item-text="text"
              item-value="id"
              v-model="form.measure"
              :loading="loadingFieldsData"
              :items="measures"
              :error-messages="measureErrors"
              @change="$v.form.measure.$touch()"
              @blur="$v.form.measure.$touch()"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text class="py-1">
        <v-select
          label="Относительно еды"
          item-text="text"
          item-value="id"
          v-model="form.meal"
          :loading="loadingFieldsData"
          :items="meals"
          :error-messages="mealErrors"
          @change="$v.form.meal.$touch()"
          @blur="$v.form.meal.$touch()"
        />
      </v-card-text>

      <v-card-text class="py-1">
        <v-subheader class="font-weight-bold px-0">Курс</v-subheader>

        <v-row>
          <v-col class="py-0">
            <v-text-field
              label=""
              v-model.number="form.course.count"
              :error-messages="courseCountErrors"
              @input="$v.form.course.count.$touch()"
              @blur="$v.form.course.count.$touch()"
            />
          </v-col>

          <v-col cols="auto" class="align-self-end text-center py-0">раз в</v-col>

          <v-col class="py-0">
            <v-text-field
              label=""
              v-model.number="form.course.period"
              :error-messages="coursePeriodCountErrors"
              @input="$v.form.course.period.$touch()"
              @blur="$v.form.course.period.$touch()"
            />
          </v-col>

          <v-col class="py-0">
            <v-select
              label="Период"
              item-value="id"
              item-text="text"
              v-model.number="form.course.inPeriod"
              :loading="loadingFieldsData"
              :items="course.periods"
              :error-messages="coursePeriodTypeErrors"
              @change="$v.form.course.inPeriod.$touch()"
              @blur="$v.form.course.inPeriod.$touch()"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col class="py-0">
            <v-text-field
              label="В течение"
              v-model.number="form.course.during"
              :error-messages="courseDuringCountErrors"
              @input="$v.form.course.during.$touch()"
              @blur="$v.form.course.during.$touch()"
            />
          </v-col>

          <v-col class="py-0">
            <v-select
              label="Период"
              item-value="id"
              item-text="text"
              v-model.number="form.course.duringPeriod"
              :loading="loadingFieldsData"
              :items="course.periods"
              :error-messages="courseDuringTypeErrors"
              @change="
                changeDuringPeriodType($event);
                $v.form.course.duringPeriod.$touch();
              "
              @blur="$v.form.course.duringPeriod.$touch()"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col class="py-0" cols="6" md="4" v-for="(v, idx) in $v.form.course.times.$each.$iter" :key="`time-${idx}`">
            <!-- <time-picker
              v-model="v.time.$model"
              :label="`№${v.$model.idx + 1} в`"
              :error-messages="[v.time.$error ? 'Обязательно' : '']"
              @input="v.time.$touch()"
              @blur="v.time.$touch()"
            /> -->
            <v-text-field
              type="time"
              v-model="v.time.$model"
              :label="`№${v.$model.idx + 1} в`"
              :error-messages="[v.time.$error ? 'Обязательно' : '']"
              @input="v.time.$touch()"
              @blur="v.time.$touch()"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text class="py-1">
        <v-subheader class="font-weight-bold px-0">Период</v-subheader>

        <v-row dense>
          <v-col>
            <date-picker
              label="C"
              :hide-details="false"
              v-model="form.period.from"
              :error-messages="periodFromErrors"
              @input="$v.form.period.from.$touch()"
              @blur="$v.form.period.from.$touch()"
            />
          </v-col>

          <v-col>
            <v-text-field label="До" readonly disabled v-model="form.period.to" :error-messages="periodToErrors" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-expansion-panels flat hover v-model="selectedPanel">
        <v-expansion-panel>
          <v-expansion-panel-header>От какого заболевания</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs fixed-tabs v-model="selectedTab">
              <v-tab>Диагноз(ы)</v-tab>
              <v-tab>Поиск заболевания по МКБ-10</v-tab>
            </v-tabs>

            <v-tabs-items v-model="selectedTab">
              <v-tab-item>
                <v-card flat>
                  <v-card-text class="py-1">
                    <div class="d-flex">
                      <v-autocomplete
                        label="Диагноз"
                        hide-no-data
                        hide-selected
                        item-text="name"
                        item-value="customerDiseaseId"
                        return-object
                        v-model="form.disease"
                        :items="customerDiseasesList"
                        :error-messages="ustomerDiseaseIdErrors"
                        class="mr-3"
                      >
                      </v-autocomplete>
                      <v-select
                        v-model="form.disease.type_id"
                        :items="diseasesTypes"
                        item-text="name"
                        item-value="id"
                        label="Тип диагноза"
                        :error-messages="diseaseTypeIdErrors"
                        single-line
                      ></v-select>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <searchMKB10 v-model="form.disease" @select="onSelectMKB10" />
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-divider class="mt-4"></v-divider>

      <v-card-actions>
        <v-btn id="form-add-medicine-cancel" color="primary" text @click="close(true)">Отменить</v-btn>
        <v-spacer></v-spacer>
        <v-btn id="form-add-medicine-submit" color="primary" text @click="submit">
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </form>
</template>

<script>
import { numeric, required } from "vuelidate/lib/validators";
import { messageHelper } from "@/services/validation-helper";
import DatePicker from "@/components/forms/DatePicker";
import SearchMKB10 from "@/components/SearchMKB10";
import Loader from "@/components/Loader";
import TimePicker from "@/components/forms/TimePicker";
import dayjs from "dayjs";

// Дефолтное состояние формы
const formState = {
  drugId: "", // item_name
  form: "", // item_form
  manufacturer: "", // item_manfrer
  receptionMethod: "", // item_method
  dosage: "", // item_method_dosage
  measure: "", // item_method_measure
  meal: "", // Относительно еды
  course: {
    count: 1, //item_course1
    period: 1, // item_course2
    inPeriod: 1, // item_course3
    during: 1, // item_course_during
    duringPeriod: 1, // item_course_during2
    times: [], // item_time(1) - item_time(n)
  },
  period: {
    from: dayjs().format("YYYY-MM-DD"),
    to: dayjs()
      .add(1, "day")
      .format("YYYY-MM-DD"),
  },
  disease: {
    id: "", // diseaseUserInput
    customerDiseaseId: "", // diseaseUserSelect
    name: "",
    code: "",
    type_id: "",
  },
};

export default {
  name: "AddMedicine",

  components: { TimePicker, DatePicker, SearchMKB10, Loader },
  props: {
    date: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    diseasesTypes: [],
    loadingForm: false,
    selectedTab: 0,
    selectedPanel: 0,
    loadingFieldsData: false,

    drugFormsListLoading: false,
    drugFormsList: [],

    manufacturerListLoading: false,
    manufacturerList: [],

    receptionMethods: [],
    measures: [],
    meals: [],
    course: {
      periods: [],
    },

    drugsList: [],
    loadingDrugs: false,
    searchDrugs: null,
    searchDisease: null,
    loadingDiseases: false,
    diseasesList: [],

    searchTimeout: null,

    customerDiseasesList: [],

    form: { ...formState },
  }),

  validations: {
    form: {
      drugId: { required },
      form: { required },
      manufacturer: { required },
      receptionMethod: { required },
      dosage: { required, numeric },
      measure: { required },
      meal: { required },
      course: {
        count: { required, numeric },
        period: { required, numeric },
        inPeriod: { required },
        during: { required, numeric },
        duringPeriod: { required },
        times: {
          required,
          $each: { time: { required } },
        },
      },
      period: {
        from: { required },
        to: { required },
      },
      disease: {
        code: { required },
        type_id: { required },
      },
    },
  },

  computed: {
    nameErrors() {
      return messageHelper(this.$v.form.drugId);
    },

    drugFormErrors() {
      return messageHelper(this.$v.form.form);
    },

    manufacturerErrors() {
      return messageHelper(this.$v.form.manufacturer);
    },

    receptionMethodErrors() {
      return messageHelper(this.$v.form.receptionMethod);
    },

    dosageErrors() {
      return messageHelper(this.$v.form.dosage);
    },

    measureErrors() {
      return messageHelper(this.$v.form.measure);
    },

    mealErrors() {
      return messageHelper(this.$v.form.meal);
    },

    courseCountErrors() {
      return messageHelper(this.$v.form.course.count);
    },

    coursePeriodCountErrors() {
      return messageHelper(this.$v.form.course.period);
    },

    coursePeriodTypeErrors() {
      return messageHelper(this.$v.form.course.inPeriod);
    },

    courseDuringCountErrors() {
      return messageHelper(this.$v.form.course.during);
    },

    courseDuringTypeErrors() {
      return messageHelper(this.$v.form.course.duringPeriod);
    },

    periodFromErrors() {
      return messageHelper(this.$v.form.period.from);
    },

    periodToErrors() {
      return messageHelper(this.$v.form.period.to);
    },

    diseaseCodeErrors() {
      return messageHelper(this.$v.form.disease.code);
    },
    diseaseTypeIdErrors() {
      return messageHelper(this.$v.form.disease.type_id);
    },
    ustomerDiseaseIdErrors() {
      return messageHelper(this.$v.form.disease.code);
    },
  },

  watch: {
    // Посик леакртсва по названию
    searchDrugs(value) {
      // Items have already been requested
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.loadingDrugs = true;
        this.$http
          .get(`v1/medicines/search`, { params: { query: value } })
          .then(response => {
            this.drugsList = response.data.data;
            this.loadingDrugs = false;
          })
          .catch(e => {
            console.error("Ошибка поиска по лекарствам", e.response.data.message);
            this.loadingDrugs = false;
          });
      }, 300);
    },
    "form.period.from": function(newVal, oldVal) {
      if (newVal === oldVal) return;

      this.changeDuringPeriodType(this.form.course.duringPeriod);
    },

    "form.course.during": function(newVal, oldVal) {
      if (newVal === oldVal) return;

      this.changeDuringPeriodType(this.form.course.duringPeriod);
    },

    "form.course.count": {
      handler: function(newVal) {
        const count = +newVal;
        this.form.course.times = [];
        for (let i = 0; i < count; i++) {
          this.form.course.times.push({ time: "", idx: i });
        }
      },
      immediate: true,
    },

    // Посик по названию болезни
    searchDisease(value) {
      // Items have already been requested
      if (this.loadingDiseases) return;

      if (this.form.disease && !value && value !== this.form.disease.name) {
        return;
      }

      this.loadingDiseases = true;

      this.$http
        .get(`v1/diseases`, { params: { search: value } })
        .then(response => {
          this.diseasesList = response.data.data;
          this.loadingDiseases = false;
        })
        .catch(e => {
          console.error("Ошибка поиск по болезням", e.response.data.message);
          this.loadingDiseases = false;
        });
    },
  },

  mounted() {
    console.log(`this.date =>`, this.date);
    if (this.date) {
      this.form.period.from = this.date;
    }
    this.loadFormFieldsData();
    this.$http
      .get(`v1/diseases/types`)
      .then(response => {
        this.diseasesTypes = response.data.data;
        this.loadingDiseases = false;
      })
      .catch(e => {
        console.error("Ошибка загрузки типов заболеваний", e.response.data.message);
        this.loadingDiseases = false;
      });
  },

  methods: {
    loading(val) {
      this.loadingForm = val;
      this.$emit("loading", val);
    },

    /**
     * Сброс формы
     */
    resetForm() {
      this.$v.$reset();
      this.form = { ...formState };
    },

    /**
     * Отправка формы
     */
    async submit() {
      this.$v.form.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) return;
      this.loading(true);

      try {
        const response = await this.$http.post(`v1/customers/${this.$store.state.customer.id}/medicines`, this.form);
        this.loading(false);

        if (response.data.success) {
          this.$store.commit("drugs/ADD_ITEM", response.data.data);
          this.$store.commit("drugs/INCREASE_META_TOTAL", response.data.data);
          this.$dialog.message.success(response.data.message);
          this.close();
        }
      } catch (e) {
        this.loading(false);
        this.$dialog.message.error(e.response.data.message);
        console.error("Ошибка добавления лекарства для пациента", e.response.data.message);
      }
    },

    /**
     * Закрытия модального окна
     */
    close() {
      this.resetForm();
      this.dialog = false;
      this.loadingForm = false;
      this.$emit("close");
      this.$emit("submit");
    },

    /**
     * Вызывает форму добавления нового лекарства
     */
    addNewMedicineName() {
      alert("Новое лекарство");
    },

    onSelectMKB10(item) {
      this.diseasesList = [item];
      this.selectedTab = 0;
    },

    /**
     * Обработчик выбора лекарства
     */
    selectDrug(drugId) {
      this.loadManufactures(drugId);
      this.loadDrugForms(drugId);
    },

    /**
     * Изменяет период и диапазон дат "С - ДО"
     */
    changeDuringPeriodType(period) {
      const format = "YYYY-MM-DD";
      switch (period) {
        case 1:
          this.form.period.to = dayjs(this.form.period.from)
            .add(this.form.course.during, "day")
            .format(format);
          break;
        case 2:
          this.form.period.to = dayjs(this.form.period.from)
            .add(this.form.course.during, "week")
            .format(format);
          break;
        case 3:
          this.form.period.to = dayjs(this.form.period.from)
            .add(this.form.course.during, "month")
            .format(format);
          break;
        default:
          break;
      }
    },

    async loadManufactures(drugId) {
      try {
        this.manufacturerListLoading = true;
        const response = await this.$http.get(`v1/medicines/${drugId}/manufacturers`);
        this.manufacturerList = response.data.data;
        this.manufacturerListLoading = false;

        if (this.manufacturerList.length === 1) {
          this.form.manufacturer = this.manufacturerList[0].id;
        }
      } catch (e) {
        console.error("Ошибка загрузки производителей", e.response.data.message);
      }
    },

    async loadDrugForms(drugId) {
      try {
        this.drugFormsListLoading = true;
        const response = await this.$http.get(`v1/medicines/${drugId}/forms`);
        this.drugFormsList = response.data.data;
        this.drugFormsListLoading = false;

        if (this.drugFormsList.length === 1) {
          this.form.form = this.drugFormsList[0].id;
        }
      } catch (e) {
        console.error("Ошибка загрузки форм выпуска лекарства", e.response.data.message);
      }
    },

    /**
     * Загружает данные для полей формы
     *
     * @return void
     */
    async loadFormFieldsData() {
      const [methods, measures, meals, coursePeriods, customerDiseases] = await Promise.all([
        this.$http.get(`v1/medicines/methods`),
        this.$http.get(`v1/medicines/measures`),
        this.$http.get(`v1/medicines/meals`),
        this.$http.get(`v1/medicines/course-periods`),
        this.$http.get(`v1/customers/${this.$store.state.customer.id}/diseases?sort_field=&sort_direction=&per_page=100`),
      ]);

      this.receptionMethods = methods.data.data;
      this.measures = measures.data.data;
      this.meals = meals.data.data;
      this.course.periods = coursePeriods.data.data;
      this.customerDiseasesList = customerDiseases.data.data.map(item => ({
        customerDiseaseId: +item.id,
        id: +item.icd10_id,
        code: item.icd10 ? item.icd10.code : "",
        name: item.title || (item.icd10 && item.icd10.translations ? item.icd10.translations.ru.name : ""),
      }));
    },
  },
};
</script>

<style scoped></style>
